<template>
  <div class="task-content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header">
      <div class="back" @click="$router.go(-1)">返回</div>
      <div class="task-title">
        {{ taskTitle && newTaskTitleTxt ? taskTitle + '(' + newTaskTitleTxt + ')' : taskTitle || '配置任务包' }}
      </div>
    </div>
    <div class="title">基本配置</div>
    <el-form label-width="120px" label-position="right" class="demo-ruleForm">
      <div class="basic-conetent">
        <div style="display: flex; width: 800px">
          <el-form-item v-if="detail.tenantName" style="width: 400px;">
            <span slot="label">委托方： </span>
            <div>{{ tenantName }}</div>
            <div></div>
          </el-form-item>
          <el-form-item v-if="detail.serviceTenantName" style="width: 400px;">
            <span slot="label">服务商： </span>
            <div>{{ detail.serviceTenantName }}</div>
            <div></div>
          </el-form-item>
        </div>
        <div style="display: flex; width: 800px">
          <el-form-item v-if="detail.organisationInfo" style="width: 400px;">
            <span slot="label">执行部门： </span>
            <!--转派展示organisationInfo无转派展示organisationInfo-->
            <div style="text-align:left;line-height: 30px;width: 280px;">{{
              getDepartmentName(detail.oldOrganisationInfo||detail.organisationInfo) }}</div>
          </el-form-item>
          <el-form-item label="执行日期：" style="width: 400px;" v-if="timeType == '按年' || timeType == '按月' || disabled">
            <div>{{ startTime }} 至 {{ endTime }}</div>
          </el-form-item>
        </div>
      </div>

      <!-- 任务包转派 开始 -->
      <section>
        <div class="title color-red">任务包转派<i class="task-tips">（说明：表示此任务再次转派给其他执行方来完成）</i></div>
        <div class="basic-conetent">
          <div style="display: flex; width: 800px;margin-bottom:4px">
            <el-form-item v-if="detail.organisationInfo" style="width: 414px">
              <span slot="label" class="color-red">转派开关： </span>
              <el-radio-group v-model="isChangeService" :disabled="detail.state != '待受理'">
                <el-radio label="N">关闭</el-radio>
                <el-radio label="Y">开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: flex; width: 800px;padding-bottom: 10px;" v-if="isChangeService=='Y'">
            <el-form-item style="width: 400px">
              <span slot="label" style="color: red">*</span>
              <span slot="label">新执行方： </span>
              <el-select v-if="detail.state == '待受理'" style="width:280px;" @change="handleSelectFactory"
                v-model="newServiceTenantName" filterable placeholder="请选择新执行方">
                <el-option v-for="(item, index) in tenantList" :key="index" :label="item.tenantName"
                  :value="item.tenantName"></el-option>
              </el-select>
              <div v-if="detail.state != '待受理'">{{ detail.newServiceTenantName||'-' }}</div>
            </el-form-item>
            <div class="base-info">
              <div class="base-title" style="color:#606266"><span style="color: red">*</span>新执行部门：</div>
              <div class="depart-choose" v-if="detail.state == '待受理'" @click="chooseDepartmentPerson">
                <span v-if="departmentListII.length == 0" class="place-choose">请选择</span>
                <span class="place-show" v-else>{{ this.getDepartmentName(departmentListII) }} </span>
              </div>
              <div style="border: 0 none" class="depart-choose" v-else>{{this.getDepartmentName(detail.organisationInfo)
                }}</div>
            </div>
          </div>
        </div>
      </section>
      <!-- 任务包转派 结束 -->

      <!-- 任务明细 开始 -->
      <div class="title">任务明细</div>
      <!-- 数据标注类型：标注配置摘要（无传统明细行，v26.3.3） -->
      <div class="back-color-fff p16 label-config-summary" v-if="isLabelTask">
        <el-row :gutter="16">
          <el-col :span="8"><span class="sum-label">标注数据：</span>{{ labelConfigObj.datasetName || '-' }}（{{ labelConfigObj.dataAmount }}{{ labelConfigObj.dataUnit }}）</el-col>
          <el-col :span="8"><span class="sum-label">数据模态：</span>{{ labelConfigObj.dataModalName || '-' }}</el-col>
          <el-col :span="8"><span class="sum-label">质检比例：</span>{{ labelConfigObj.qcRatio != null ? labelConfigObj.qcRatio + '%' : '-' }}</el-col>
          <el-col :span="8"><span class="sum-label">标签：</span>{{ labelSnapshotText }}</el-col>
          <el-col :span="8"><span class="sum-label">预标注模型：</span>{{ labelConfigObj.modelName || '-' }}</el-col>
          <el-col :span="8"><span class="sum-label">标注经验要求：</span>{{ labelConfigObj.experience || '-' }}</el-col>
          <el-col :span="8"><span class="sum-label">科室要求：</span>{{ labelConfigObj.deptName || '-' }}</el-col>
          <el-col :span="8"><span class="sum-label">身份要求：</span>{{ labelIdentityText }}</el-col>
          <el-col :span="8"><span class="sum-label">职称/专业要求：</span>{{ labelTitleText }}</el-col>
        </el-row>
        <el-row :gutter="16" v-if="labelConfigObj.workDesc || labelConfigObj.workDetail || labelConfigObj.workRequire">
          <el-col :span="8" v-if="labelConfigObj.workDesc"><span class="sum-label">工作内容描述：</span>{{ labelConfigObj.workDesc }}</el-col>
          <el-col :span="8" v-if="labelConfigObj.workDetail"><span class="sum-label">工作内容明细：</span>{{ labelConfigObj.workDetail }}</el-col>
          <el-col :span="8" v-if="labelConfigObj.workRequire"><span class="sum-label">任务管理要求：</span>{{ labelConfigObj.workRequire }}</el-col>
        </el-row>
        <!-- 导出标注结果（二期接口清单 #10：异步导出，每 5000 条一个文件；接口占位 F0 对齐） -->
        <div class="export-row" v-if="detail.state == '已派发' || detail.state == '进行中' || detail.state == '已结束'">
          <el-button type="info" size="mini" :loading="labelExporting" @click="exportLabelResult">导出标注结果</el-button>
          <span class="export-tip">异步导出，每 5000 条生成一个文件</span>
        </div>
      </div>
      <!-- <div class="sum-txt" v-if="detail.state == '待派发' || detail.state == '已派发'">合计：任务名称{{ detail.taskDetailCount }}个 ，下发部门{{ getDeliverOrg(detail) }}个，已计算出{{getDeliverStaff(detail)}}人的任务</div> -->
      <section class="btn-groups btn-operate" v-if="detail.timeState!='已结束'||detail.autoForecastOpen=='1'">
        <el-button class="btn-common" size="mini" type="info" v-if="detail.autoForecastOpen=='1'"
          @click="visible10=true">查看预测</el-button>
        <template v-if="isShowModifyBtn(detail) && !isLabelTask">
          <el-button class="btn-common" size="mini" type="info"
            @click="visible6 = true;fileList = [];">批量调整任务量</el-button>
          <el-button class="btn-common" size="mini" type="info" @click="showDetail=true;">修改人员任务</el-button>
          <el-button class="btn-common" type="info" size="mini" @click="showDelete=true;">删除人员任务</el-button>
        </template>
        <el-button v-if="isShowSetCancelBtn(detail)" class="btn-common" size="mini" type="info"
          @click="setCancel">设为失效</el-button>
        <el-button v-if="isShowBeginFlowBtn(detail)" class="btn-common" size="mini" type="info"
          @click="beginChangeFlow">开启变更流程</el-button>
      </section>
      <div class="back-color-fff p16" style="padding-bottom:0;" v-show="!isLabelTask">
        <el-table :data="tableDataII" border stripe header-cell-class-name="table_header">
          <el-table-column prop="parentTemplateDetailName" label="平台任务名称" width="200" show-overflow-tooltip
            header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.parentTemplateDetailName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskType" label="任务大类" width="150" show-overflow-tooltip header-align="center"
            align="left">
            <template slot-scope="scope">{{ scope.row.taskType || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="项目任务名称" width="200" show-overflow-tooltip header-align="center"
            align="left">
            <template slot-scope="scope">
              <div v-if="scope.row.contractTaskType != 0">
                <el-tooltip effect="dark"
                  :content="scope.row.contractTaskType==2?'该任务在当前企业合同中未签约，请尽快签署补充协议变更合同任务':'该任务未签署合同，请尽快签署合'"
                  placement="right-start">
                  <span>{{ scope.row.taskContentName }}<img src="../../assets/icon/import_warning.png" alt=""
                      style="width:15px;" /></span>
                </el-tooltip>
              </div>
              <div v-else>{{ scope.row.taskContentName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="menuName" label="系统功能" width="120" show-overflow-tooltip header-align="center"
            align="left">
            <template slot-scope="scope">{{scope.row.surveyTitle|| scope.row.menuName || '-' }}</template>
          </el-table-column>
          <el-table-column :label="detail.taskPriceModel == 2 && detail.state == '待受理' ? '业务员基础报价' : '业务员价格'" width="160"
            header-align="center" align="left">
            <template slot-scope="scope">
              <span v-if="detail.taskPriceModel == 1 || (detail.state == '待受理' && detail.taskPriceModel == 2)">
                {{scope.row.taskPrice }} {{ scope.row.taskPriceUnit }}</span>
              <span
                v-if="detail.state != '待受理' && detail.taskPriceModel == 2 && scope.row.staffMinPrice != scope.row.staffMaxPrice">
                {{ scope.row.staffMinPrice }} ～ {{ scope.row.staffMaxPrice }}{{ scope.row.taskPriceUnit }}</span>
              <span
                v-if="detail.state != '待受理' && detail.taskPriceModel == 2 && scope.row.staffMinPrice == scope.row.staffMaxPrice">
                {{ scope.row.staffMinPrice }}{{ scope.row.taskPriceUnit }}</span>
            </template>
          </el-table-column>

          <el-table-column label="计算方式" width="90" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskTotalType}}</template>
          </el-table-column>
          <el-table-column prop="taskTotal" show-overflow-tooltip label="任务量" header-align="center" align="left"
            width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.taskTotalType!='固定量人均'&&scope.row.taskTotalType!='不限量'"
                style="display: flex; align-items: center;">
                <div>{{ scope.row.taskTotal }}</div>
                <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                <span style="color:#FF991C;">({{ scope.row.countRule }})</span>
              </div>
              <div v-if="scope.row.taskTotalType=='固定量人均'" style="display: flex; align-items: center;">
                <!-- SJBZ 行以量定人：人均未配置（空/0）时回退显总量（数据集条目数）；普通行仍显人均 -->
                <div>{{ isSjbzRow(scope.row) ? (scope.row.taskAvg > 0 ? scope.row.taskAvg : scope.row.taskTotal) : scope.row.taskAvg }}</div>
                <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                <span style="color:#FF991C;">({{ scope.row.countRule }})</span>
              </div>
              <div v-if="scope.row.taskTotalType=='不限量'" style="display: flex; align-items: center;">
                <div>不限量 <span style="color:#FF991C;">({{ scope.row.countRule }})</span></div>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="超量上限拦截" header-align="center" width="110" align="left">
            <span slot-scope="scope">
              {{scope.row.isOpenMaxTask=='N'?'否':'是，'+ scope.row.maxTaskValue+'%'}}
            </span>
          </el-table-column>
          <!-- N7 受理页标注行三列（2026-09-16 受理交互定稿 Q4/Q5：只读纯详情；位置对齐配置页=超量上限拦截之后；
               仅含 SJBZ 行的包渲染，普通行显示 '-'，普通任务包零影响） -->
          <template v-if="hasLabelRows">
            <el-table-column label="标注数据" header-align="center" align="center" width="180" show-overflow-tooltip>
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">{{ sjbzDatasetText(scope.row) }}</template>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="标注人员要求" header-align="center" align="center" width="110">
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">
                  <a v-if="sjbzReqSet(scope.row)" class="txt-color" @click="openSjbzReqView(scope.row)">查看</a>
                  <span v-else>-</span>
                </template>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="质检比例" header-align="center" align="center" width="100">
              <template slot-scope="scope">
                <template v-if="isSjbzRow(scope.row)">{{ sjbzConf(scope.row).qcRatio != null ? sjbzConf(scope.row).qcRatio + '%' : '-' }}</template>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="taskType" label="限定品种" show-overflow-tooltip width="200" header-align="center"
            align="center">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.goodsInfo && scope.row.goodsInfo.length" class="txt-color"
                  @click="handleChooseGoods(scope.$index)">共{{
                  scope.row.goodsInfo.length
                  }}个品</span>
                <span
                  v-else-if="(!scope.row.goodsInfo||!scope.row.goodsInfo.length) && isShowModifyBtn(detail)&&limitTaskDicts.indexOf(scope.row.taskContentType)>-1"
                  class="txt-color" @click="handleChooseGoods(scope.$index)">请选择</span>
                <span v-else>-</span>
              </div>

            </template>
          </el-table-column>

          <!-- <el-table-column prop="taskTag" label="品种任务量" show-overflow-tooltip width="120" header-align="center" align="left" :renderHeader="renderHeader">
            <template slot-scope="scope">
              <span v-if="!scope.row.goodsInfo">-</span>
              <span v-else style="text-decoration: underline; color: #4fa1a4; cursor: pointer" @click="addAmount(scope.$index, scope.row.goodsInfo)">{{ detail.state != '待受理' ? '点击查看品种量' : '点击填写品种量' }}</span>
            </template>
          </el-table-column> -->

          <el-table-column prop="taskTag" label="服务客户区域" show-overflow-tooltip width="120" header-align="center"
            align="left">
            <template slot-scope="scope">{{ getDeliverName(scope.row.clientArea) }}</template>
          </el-table-column>
          <el-table-column prop="bank" min-width="120px" label="操作" header-align="center" align="center" fixed="right"
            v-if="detail.state == '待派发' || detail.state == '已派发'">
            <template slot-scope="scope">
              <!-- N7 标注行：三类人员配置弹框（派发后只读）；普通行：原人员明细 -->
              <a v-if="isSjbzRow(scope.row) && detail.state == '待派发'" class="txt-color"
                @click="labelRowDetail = scope.row; showLabelRowDetail = true;">配置人员明细</a>
              <a v-else-if="isSjbzRow(scope.row)" class="txt-color"
                @click="labelRowDetail = scope.row; showLabelRowDetail = true;">查看人员明细</a>
              <a v-else class="txt-color" @click="rowDetail=scope.row;showRowDetail=true;">查看人员明细</a>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div v-if="detail.confirmTime" class="date first">
        <span>药企确认发布时间：</span>{{ detail.confirmTime | getTimeDate }}
      </div>
      <div v-if="detail.agreeTime" class="date"><span>运营受理时间：</span>{{ detail.agreeTime | getTimeDate }}</div>
      <div v-if="detail.sendTime" class="date"><span>运营派发任务时间：</span>{{ detail.sendTime | getTimeDate }}</div>
      <div v-if="detail.reportTime" class="date">
        <span>运营报告上传时间：</span>{{ detail.reportTime | getTimeDate }}
      </div>
      <div v-if="detail.payTime" class="date"><span>结算成功时间：</span>{{ detail.payTime | getTimeDate }}</div> -->

      <div class="btn-groups">
        <el-button class="btn-common btn-border-gray" size="mini" type="info" @click="$router.go(-1)">取消</el-button>
        <!-- 受理按钮（2026-09-16 晚口径反转：流程不改先分解后微调——含 SJBZ 行的包点此按钮
             弹选人框，确认即行级拆分；普通包既有提交流程零改动） -->
        <el-button class="btn-common" size="mini" type="info" @click="submitReq"
          v-if="detail.state == '待受理' && (!isLabelTask || hasLabelRows)">受理，并任务分解</el-button>
        <!-- 原来的去派发 -->
        <el-button class="btn-common" size="mini" type="info" @click="checkPost" v-if="isShowPostBtn(detail)">{{
          !detail.bizApproveVO?'去派发':'提交审核' }}</el-button>
      </div>
    </el-form>

    <!-- <el-dialog title="填写品种任务量" :visible.sync="visible2" width="40%" center>
      <el-table border :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="产品名称" show-overflow-tooltip header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="任务量" width="180" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.goodsCount" :min="0" :step="1" size="small" v-if="detail.state == '待受理'"></el-input-number>
            <div v-else>
              {{ scope.row.goodsCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品规格" show-overflow-tooltip header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.goodsSpec }}</template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible2 = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog> -->

    <el-dialog title="任务分解" :visible.sync="visible4" width="70%" center>
      <div class="title-search">
        <div>
          合计：该任务，总任务量：<span class="txt-color">{{detail.taskTotalType !='不限量'? taskDetail.taskTotal:'不限量' }}</span><span
            v-if="taskDetail.taskTotal">{{ taskDetail.taskTotalUnit }}</span>，已分解给
          <span class="txt-color">
            {{ taskDetail.taskDetailOrganisationList && taskDetail.taskDetailOrganisationList.length }}</span>个部门，<span
            class="txt-color">{{ taskDetail.staffTotal }}</span>个人员
        </div>
        <el-input v-model="serachOrgTxt" clearable class="search-box" placeholder="请输入组织"></el-input>
      </div>

      <el-table border :data="tableOrg" style="width: 100%">
        <el-table-column v-for="(item, index) in tabHead" :label="item.label" :property="item.property" :key="index"
          show-overflow-tooltip header-align="center" align="center">
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <a class="txt-color" v-if="detail.state == '待派发' || detail.state == '已派发'"
              @click="seePeople(scope.row)">查看人员明细</a>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="任务分解" :visible.sync="visible5" width="70%" center>
      <div class="title-search">
        <div>
          当前部门：{{ taskStaffDetail.organisationName }}，任务总量：<span class="txt-color">{{
            taskStaffDetail.planCount
            }}</span><span v-if="taskStaffDetail.planCount!='不限量'">{{ taskDetail.taskTotalUnit }}</span>，已分解<span
            class="txt-color">{{
            taskStaffDetail.taskDetailStaffList && taskStaffDetail.taskDetailStaffList.length
            }}</span>个人员
        </div>
        <el-input v-model="serachPeopleTxt" clearable class="search-box" placeholder="请输入名称"></el-input>
      </div>
      <el-table border :data="tableStaff" style="width: 100%">
        <el-table-column v-for="(item, index) in tabHeadII" :label="item.label" :property="item.property" :key="index"
          header-align="center" align="center">
          <template slot-scope="scope">
            <input
              v-if="scope.column.property !== 'staffName'&&scope.row[scope.column.property]!='不限量'&&detail.timeState!='已结束'"
              style="width: 100px !important" size="small" class="el-input__inner"
              v-model="scope.row[scope.column.property]" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" />
            <div v-else>{{ scope.row[scope.column.property] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer t-right" v-if="detail.timeState!='已结束'">
        <el-button plain size="medium" @click="visible5 = false">取消</el-button>
        <el-button size="medium" type="info" @click="modifyStaff">确定</el-button>
      </div>
    </el-dialog>
    <div v-if="visible6">
      <el-dialog title="批量调整任务" :visible.sync="visible6" width="45%" center>
        <div class="row-import">
          <div class="left">下载模板</div>
          <div class="right">
            <el-button type="info" @click="downloadTemplate" size="small">下载任务清单</el-button>
            <div class="tipInfo">
              注意事项：<br />
              1、 请先下载任务清单，任务清单中是当前系统自动分解后每个人的任务量明细；<br />
              2、下载后，直接修改里面的任务量数值，再导入，即可批量调整人员任务量
            </div>
          </div>
        </div>
        <div class="row-import">
          <div class="left">导入文件</div>
          <div class="right">
            <el-upload class="avatar-uploader" action="#" :limit="1" :before-upload="beforeAvatarUpload"
              :http-request="uploadImage" multiple>
              <el-button size="small" type="info">点击上传文件</el-button>
            </el-upload>
            <div class="tipInfo">
              注意事项：<br />
              1、点击文件，选择修改好的任务清单文件上传；<br />
              2、仅支持excel文件，大小
              <=10M；<br />
              3、使用 Office 2010 及以上版本，避免出现乱码<br />
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer t-right">
          <el-button plain size="medium" @click="visible6 = false">取消</el-button>
          <el-button size="medium" type="info" @click="modifyUplad">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择部门人员 开始 -->
    <ChooseUser ref="chooseDepartment" :tenantGuid="newServiceTenantGuid" @onSelect="onDepartmentSelect"></ChooseUser>
    <!-- 选择部门人员 结束 -->

    <!-- <el-dialog title="修改人员任务" :visible.sync="visible8" width="500px" :close-on-click-modal='false'>
      <template v-if="visible8">
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择任务：</span>
            <el-select v-model="taskDetailGuid" placeholder="请选择任务" filterable class="fl" style="width: 300px" @change="taskChange">
              <el-option v-for="item in tableDataII" :key="item.guid" :label="item.taskContentName" :value="item.guid"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择人员：</span>
            <el-select v-model="staffGuid" placeholder="请选择人员" filterable class="fl" style="width: 300px" @change="staffChange">
              <el-option v-for="item in staffList" :key="item.staffGuid" :label="item.staffName+'-'+item.mobileNo" :value="item.staffGuid"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm" v-if="organisationNames">
          <el-form-item>
            <span slot="label">所属组织：</span>
            <div>{{organisationNames}}</div>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">任务量：</span>
            <el-input type="number" min="0" v-model="taskCount" placeholder="请填写任务量" style="width: 300px"></el-input>
          </el-form-item>
        </el-form>
        <div class="task-tips" style="text-align:left;padding-left:120px;">注意：若数量修改为0，则人员任务删除，无法继续执行此任务，请慎重修改。</div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" plain @click="visible8 = false">取 消</el-button>
          <el-button size="medium" type="info" @click="sureTaskModify">提 交</el-button>
        </span>
      </template>
    </el-dialog> -->

    <el-dialog class="ai-class" title="查看预测规则" :visible.sync="visible10" width="50%" center>

      <div class="ai-content">
        <div class="ai-item">
          <span class="lable">执行部门：</span>
          <span class="value">{{autoForecastJson.parmValue1}}</span>
          <span class="ai-color" v-if="autoForecastJson.parmValue3">其中{{ autoForecastJson.parmValue3 }}人无历史数据无法预测</span>
        </div>
        <div class="ai-item">
          <span class="lable">预测总额：</span>
          <span class="value">{{autoForecastJson.parmValue2}}元</span>
          <span class="other1">(大写:{{autoForecastJson.parmValue2 | smallToBig}})</span>
        </div>
      </div>
      <div class="download-btns">
        <span class="lable">预测规则：</span>
      </div>
      <el-table :data="autoForecastJson.detailParam" border style="width: 100%;margin:20px 0;">
        <el-table-column prop="taskContentName" label="任务名称" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="任务占比" header-align="center" align="center">
          <template slot-scope="scope">
            <div style="display:flex;align-items:center;justify-content:center;">
              <span>{{scope.row.taskTotalPercent}}%</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="任务单价" header-align="center" align="center">
          <template slot-scope="scope">
            {{scope.row.taskPrice}}{{scope.row.taskPriceUnit}}
          </template>
        </el-table-column>
        <el-table-column label="任务量" header-align="center" align="center">
          <template slot-scope="scope">
            {{scope.row.foreCastTaskTotal}}
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="visible10 = false">关闭</el-button>
      </span>
    </el-dialog>
    <DeleteTaskNum :detail="detail" v-if="showDelete" @close="showDelete = false;getDetail();"></DeleteTaskNum>
    <ModifyTaskNum :detail="detail" v-if="showDetail" @close="showDetail = false; getDetail();"></ModifyTaskNum>
    <!-- 数据标注：选择执行人员弹框（09-16 晚口径：点【受理，并任务分解】弹出，确认即行级拆分；
         候选按行拉取、池=委托方认证人员） -->
    <LabelAssignDialog :visible.sync="labelAssignVisible" :labelRows="labelAssignRows"
      :tenantGuid="detail.tenantGuid" @confirm="splitLabelTask"></LabelAssignDialog>
    <!-- 标注行"标注人员要求"纯详情弹框（2026-09-16 定稿 Q5：共用组件 LabelReqView，与配置页详情态同源） -->
    <el-dialog :title="sjbzReqViewTitle" :visible.sync="showSjbzReqView" width="800px" top="10vh" append-to-body>
      <label-req-view v-if="showSjbzReqView" :conf="sjbzReqViewConf"></label-req-view>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="showSjbzReqView = false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 数据标注行：三类人员配置弹框（质检锁死=任务包发起人/初审交叉默认/自审禁止；仅待派发可改，派发后只读） -->
    <LabelPersonTaskSum :visible.sync="showLabelRowDetail" :taskDetailGuid="labelRowDetail && labelRowDetail.guid"
      :datasetName="labelRowDetail && labelRowDetail.taskContentName" :readonly="detail.state != '待派发'"
      :candidateTenantGuid="labelCandidateTenantGuid" :qcDefaultGuid="detail.submitStaffGuid || detail.senderStaffGuid || ''"
      :qcDefaultName="detail.submitStaffGuid ? (detail.submitStaffName || '') : (detail.senderStaffName || '')"
      @saved="getDetail" v-if="showLabelRowDetail"></LabelPersonTaskSum>
    <PersonTaskSum :detail="rowDetail" v-if="showRowDetail" @close="showRowDetail = false;"></PersonTaskSum>
    <ImportResult :importResult="importResult" ref="importResult" />
    <DeliverTips :taskDetail="detail" :detail="tipsInfo" v-if="showDeliverTips" @surePost="surePost"
      @close="showDeliverTips = false;"></DeliverTips>
    <!-- 限制品种弹窗 开始 -->
    <GoodsLimitSelect :disabled="!isShowModifyBtn(detail)" @getLimitProducts="getLimitProducts"
      :sendTenantGuid="detail.tenantGuid" :taskList="tableDataII" :taskIndex="currentIndex" :showFromLevel="visible2"
      @closeGoodsLimit="visible2 = false"></GoodsLimitSelect>
    <!-- 限制品种弹窗 结束 -->

  </div>
</template>

<script>
  import moment from 'moment';
  import DeleteTaskNum from './components/DeleteTaskNum.vue';
  import ModifyTaskNum from './components/ModifyTaskNum.vue';
  import PersonTaskSum from './components/PersonTaskSum.vue';
  import DeliverTips from './components/DeliverTips.vue';
  import ChooseUser from './components/chooseUser';
  import  GoodsLimitSelect from '@/components/GoodsLimitSelect';
  import ImportResult from './components/ImportResult.vue';
  import LabelAssignDialog from './components/LabelAssignDialog.vue';
  import LabelPersonTaskSum from './components/LabelPersonTaskSum.vue';
  import LabelReqView from './components/LabelReqView.vue';
  import { LABEL_TASK_TYPE } from './enum.js';
  export default {
    components: {
      ChooseUser,
      ModifyTaskNum,
      PersonTaskSum,
      DeliverTips,
      DeleteTaskNum,
      GoodsLimitSelect,
      ImportResult,
      LabelAssignDialog,
      LabelPersonTaskSum,
      LabelReqView
    },
    data() {
      return {
        importResult:{},
        limitTaskDicts:[],
        currentIndex:null,
        showDelete:false,
        tipsInfo:null,
        showDeliverTips:false,
        labelRowDetail: null, //数据标注行三类人员弹框当前行
        showLabelRowDetail: false,

        rowDetail:{},
        showRowDetail:false,

        showDetail:false,
        iframeSh:false,
        iframeSrc:'',

        newTaskTitleTxt:'',
        visible10:false,
        timeType: '',
        timeRange: '',
        year: '',
        month: '',
        startTime: '',
        endTime: '',
        taskTitle: '',
        tenantName: '',
        tenantList: [],
        taskContentList: [],
        tableDataII: [],
        visible2: false,
        page: {
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          taskContentName: '',
          tenantName: '',
          isUse: 'Y',
          tenantGuid: localStorage.guid,
          serviceTenantGuid: localStorage.guid
        },
        tableData: [],
        multipleSelection: [],
        fullscreenLoading: false,
        disabled: false,
        detail: {},

        goodsIndex: 0,

        visible4: false,
        taskDetail: {},
        tableOrg: [],
        tabHead: [],

        visible5: false,
        tableStaff: [],
        tabHeadII: [],
        taskStaffDetail: {},

        visible6: false,
        fileList: [],

        sendTenantList: [],

        supertubeFlag: localStorage.supertubeFlag,//当前用户是否是超级运营公司
        // changeServiceType:'2',//默认是药企
        isChangeService: 'N',//是否转派
        newServiceTenantName: '',//新执行公司
        newServiceTenantGuid: '',
        visible7: false,
        departmentListII: [],
        filterTextII: '',
        areaDataII: [],
        delListII: [],
        filterTextII: '',
        organisationInfo: null,
        defaultPropsII: {
          id: 'guid',
          label: 'organisationName',
          children: 'children',
          disabled: this.disabledTreeNode,
        },

        visible8: false,
        taskDetailGuid: '',
        staffGuid: '',
        staffList: [],
        taskCount: '',
        detailGuid: '',
        organisationNames: '',
        serachOrgTxt:'',
        tableOriginOrg:[],
        serachPeopleTxt:'',
        tableOriginStaff:[],
        autoForecastJson:{
            parmValue1:'',
            parmValue2:'',
            parmValue3:'',
            detailParam:[]
        },
        // ===== v26.3.3 数据标注 =====
        labelAssignVisible: false, //选择执行人员弹框（受理按钮弹出，确认即拆分）
        labelConfigObj: {}, //协配的标注配置（摘要展示）
        labelExporting: false, //导出标注结果
        sjbzReqViewRow: null, //标注人员要求纯详情弹框当前行
        showSjbzReqView: false,

      };
    },
    computed: {
      // 数据标注任务类型分支（宽松等于防后端返回数字类型，与全工程 taskType 判断风格一致）
      isLabelTask() {
        return this.detail.taskType == LABEL_TASK_TYPE;
      },
      // N7 行级化：明细含 SJBZ 标注行即走行级链（混合包也进弹框；受理按钮/拆分提交按此分流）
      hasLabelRows() {
        return (this.detail.taskDetailList || []).some((row) => row.taskContentType === 'SJBZ');
      },
      // 标注行清单（LabelAssignDialog 逐行选人入参；数据量/单位取明细行快照）
      labelAssignRows() {
        return (this.detail.taskDetailList || [])
          .filter((row) => row.taskContentType === 'SJBZ')
          .map((row) => ({
            taskDetailGuid: row.guid,
            datasetName: row.taskContentName,
            dataAmount: row.taskTotal,
            dataUnit: row.taskTotalUnit,
          }));
      },
      // 三类人员候选的执行方租户（2026-09-23 口径：非转派=委托方/药企、转派=三方，初审复审候选均在执行方池）
      labelCandidateTenantGuid() {
        return this.isChangeService === 'Y' ? this.detail.newServiceTenantGuid : this.detail.tenantGuid;
      },
      // 标注人员要求纯详情弹框（Q5：共用组件按行级 labelConfig 快照展示，零接口依赖）
      sjbzReqViewTitle() {
        const name = this.sjbzReqViewRow ? this.sjbzReqViewRow.taskContentName : '';
        return name ? `【${name}】标注人员要求` : '标注人员要求';
      },
      sjbzReqViewConf() {
        return this.sjbzReqViewRow ? this.sjbzConf(this.sjbzReqViewRow) : {};
      },
      labelSnapshotText() {
        // FOUR-3001：多标签（labelSnapshots 数组）优先，兼容旧单标签（labelSnapshot 对象）；
        // 标签名称为 | 合并串，展示统一中文顿号渲染（R4，与 LabelTemplateSelect optionLabel 口径一致）
        const conf = this.labelConfigObj;
        const snaps = (conf.labelSnapshots && conf.labelSnapshots.length)
          ? conf.labelSnapshots
          : (conf.labelSnapshot ? [conf.labelSnapshot] : []);
        if (!snaps.length) return '-';
        return snaps.map((s) => (s.templateName || '').replace(/\|/g, '、') + (s.labelName ? `（${s.labelName}）` : '')).join('；');
      },
      labelIdentityText() {
        return { '1': '医生', '2': '护士', '3': '药师', '4': '技师', '5': '医学生', '6': '其他' }[this.labelConfigObj.identity] || '-';
      },
      labelTitleText() {
        const conf = this.labelConfigObj;
        const names = (conf.titleNames || []).join('、');
        if (conf.identity === '5') return conf.majorName || '-';
        return names || '-';
      },
    },
    created() {
      this.getOpertateList();
      this.getDetail();
      this.getLevelList();
      //this.getSendTenantList();
    },
    watch: {
      serachOrgTxt(val){
        var tableOriginOrg = this.tableOriginOrg;
        console.log(tableOriginOrg)
        if(!val){
          this.tableOrg = tableOriginOrg;
        }else{
          var str = tableOriginOrg
          var key = val;
          var arr=[]
          for (let index = 0; index < tableOriginOrg.length; index++) {
          if (str[index].organisationName.indexOf(key)>=0) {
            arr.push(str[index]);//返回满足条件的数据
          }}
          this.tableOrg = arr;
        }

      },
      serachPeopleTxt(val){
        var tableOriginStaff = this.tableOriginStaff;
        console.log(tableOriginStaff)
        if(!val){
          this.tableStaff = tableOriginStaff;
        }else{
          var str = tableOriginStaff
          var key = val;
          var arr=[]
          for (let index = 0; index < tableOriginStaff.length; index++) {
          if (str[index].staffName.indexOf(key)>=0) {
            arr.push(str[index]);//返回满足条件的数据
          }}
          this.tableStaff = arr;
        }

      },
      year(year) {
        if (this.disabled) return;
        if (!year) return;
        this.startTime = year + '-01-01';
        this.endTime = year + '-12-31';
      },
      month(month) {
        if (this.disabled) return;
        if (!month) return;
        var tenantList = this.tenantList;
        var tenantGuid;
        var reqDate = month + '-01';
        tenantList.forEach((item) => {
          if (item.tenantName == this.tenantName) {
            tenantGuid = item.guid;
          }
        });
        if (!tenantGuid) return;
        this.api
          .get(
            `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
            reqDate +
            '&tenantGuid=' +
            tenantGuid,
          )
          .then((resp) => {
            if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.startTime = resp.data.data.split(',')[0];
              this.endTime = resp.data.data.split(',')[1];
            }
          });
      },
      timeType() {
        if (this.disabled) return;
        this.startTime = '';
        this.endTime = '';
        this.year = '';
        this.month = '';
      },
    },
    methods: {
      getOpertateList() {
        let self = this;
        self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, { 'pageIndex': 1, 'pageSize': -1, 'enterpriseCates': ['9901'] }).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      renderHeader: function (h, { column, $index }) {
        return [
          column.label,
          h(
            'el-tooltip',
            {
              props: {
                placement: 'top',
                effect: 'dark',
                //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
              },
            },
            [
              h(
                'div',
                {
                  //当前div是为了实现换行，就这换行研究了好久。。。
                  slot: 'content',
                },
                ['每个品种的任务量 = 任务量除以品种个数'],
              ),
              h('span', {
                //问号模块
                class: {
                  'el-icon-question': true,
                },
              }),
            ],
          ),
        ];
      },
      handleCounterChange(goodsIndex, detail) {
        var tableDataII = this.tableDataII;
        console.log();
        if (detail.goodsInfo && detail.goodsInfo.length != 0) {
          var list = detail.goodsInfo;
          list.forEach((item) => {
            item.goodsCount = Math.ceil(detail.taskTotal / list.length);
          });
          this.tableDataII[goodsIndex].goodsInfo = list;
        }
      },
      //点击填写数量
      addAmount(goodsIndex, list) {
        this.visible2 = true;
        this.goodsIndex = goodsIndex;
        this.tableData = list;
      },
      getDetail() {
        var self = this;
        if (!this.$route.query.guid) return;
        if (this.$route.query.is_edit) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }

        var req = {
          guid: this.$route.query.guid,
        };
        this.fullscreenLoading = true;
        self.api.get(`/${serverConfig.msSalesPerformService}/task/data/get-base-detail`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            var detail = res.data.data;
            this.taskTitle = detail.taskTitle;
            this.tenantName = detail.tenantName;
            this.timeType = detail.timeType;
            this.autoForecastJson = detail.autoForecastJson?JSON.parse(detail.autoForecastJson):{
                parmValue1:'',
                parmValue2:'',
                parmValue3:'',
                detailParam:[]
            }
            setTimeout(() => {
              this.startTime = moment(detail.startTime).format('YYYY-MM-DD');
              this.endTime = moment(detail.endTime).format('YYYY-MM-DD');
            }, 100);
            this.departmentData = [
              {
                organisationName: detail.senderStaffName,
                guid: detail.senderStaffGuid,
              },
            ];
            this.departmentList = [
              {
                organisationName: detail.senderStaffName,
                guid: detail.senderStaffGuid,
              },
            ];

            this.tableDataII = detail.taskDetailList;
            var tableDataII = this.tableDataII;
            tableDataII.forEach((item) => {
              if (item.goodsInfo) {
                item.goodsInfo = JSON.parse(item.goodsInfo);
              }
              if (item.taskPrice && item.taskTotal) {
                item.taskTarget = item.taskPrice * item.taskTotal;
                item.taskTarget = item.taskTarget.toFixed(2);
              } else {
                item.taskTarget = 0;
              }
            });
            this.tableDataII = tableDataII;

            this.detail = detail;
            this.isChangeService = detail.isChangeService || 'N'
            // 数据标注配置摘要（占位契约字段，F0 对齐后核对；脏数据降级空对象防中断回显）
            if (detail.labelConfig) {
              try {
                this.labelConfigObj = JSON.parse(detail.labelConfig) || {};
              } catch (e) {
                console.log('labelConfig parse error', e);
                this.labelConfigObj = {};
              }
            } else {
              this.labelConfigObj = {};
            }
            // this.changeServiceType = detail.changeServiceType||'2'


            this.multipleSelection = detail.taskDetailList;
            this.$forceUpdate();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    
      },
      //导出标注结果（二期 #10：异步导出每 5000 条一文件；接口占位 /label-task/export-result，F0 对齐）
      exportLabelResult() {
        this.labelExporting = true;
        this.api
          .postJson(`/${serverConfig.msSalesPerformService}/label-task/export-result`, {
            taskMainGuid: this.$route.query.guid,
          })
          .then((res) => {
            this.labelExporting = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success("导出任务已提交，完成后可在消息/导出中心下载");
            } else {
              this.$message.error(res.data.msg || "导出失败");
            }
          })
          .catch(() => {
            this.labelExporting = false;
          });
      },
      // ===== 受理页标注行（2026-09-16 定稿：行内配置人员+只读三列） =====
      isSjbzRow(row) {
        return row && row.taskContentType === 'SJBZ';
      },
      // 行级 labelConfig 解析（与配置页 templateConfig 同源结构；$set 保证列内文本响应式；脏数据降级空对象）
      sjbzConf(row) {
        if (!row) return {};
        if (!row.__sjbzConf) {
          try {
            this.$set(row, '__sjbzConf', row.labelConfig ? (JSON.parse(row.labelConfig) || {}) : {});
          } catch (e) {
            this.$set(row, '__sjbzConf', {});
          }
        }
        return row.__sjbzConf;
      },
      // 标注人员要求是否已设置（有任一配置项才给"查看"入口）
      sjbzReqSet(row) {
        const conf = this.sjbzConf(row);
        return !!(conf.labelSnapshot || (conf.labelSnapshots && conf.labelSnapshots.length) || conf.modelGuid
          || conf.deptGuid || conf.identity
          || (conf.titleGuids && conf.titleGuids.length) || conf.majorGuid || conf.experience);
      },
      // 标注数据列文本：数据集名（数据量+单位）
      sjbzDatasetText(row) {
        const conf = this.sjbzConf(row);
        if (!conf.datasetName) return '-';
        return conf.dataAmount != null && conf.dataAmount !== ''
          ? `${conf.datasetName}（${conf.dataAmount}${conf.dataUnit || ''}）`
          : conf.datasetName;
      },
      openSjbzReqView(row) {
        this.sjbzReqViewRow = row;
        this.showSjbzReqView = true;
      },
      //去分解
      // N7 行级化：LabelAssignDialog emit labelAssignGroups（逐行选人）；taskDetailList 只传普通行子集
      //（SJBZ 行走后端 splitLabelTask 行级拆分，混入普通分解链会误炸——后端以库内 SJBZ guid 集双保险过滤）
      // v26.3.3 受理自动分解：auto=true 时不带 labelAssignGroups、带 autoLabelAssign——后端按五条件自动匹配
      // 标注人员并分配数据量（认证审核通过+至少一张证书未过期+已签平台协议+科室/身份/职称要求）
      splitLabelTask(labelAssignGroups, auto) {
        var self = this;
        var taskDetailList = this.tableDataII
          .filter((item) => item.taskContentType !== 'SJBZ')
          .map((item) => ({
            guid: item.guid,
            taskPrice: +item.taskPrice,
            taskTotal: +item.taskTotal,
            goodsInfo: item.goodsInfo ? JSON.stringify(item.goodsInfo) : null,
            taskTotalType: item.taskTotalType
          }));
        var req = {
          guid: this.$route.query.guid,
          state: '待派发',
          currentTenantGuid: localStorage.guid,
          taskDetailList,
          labelAssignGroups: (labelAssignGroups || []).map((group) => ({
            taskDetailGuid: group.taskDetailGuid,
            items: (group.items || []).map((item) => ({
              staffGuid: item.staffGuid,
              staffName: item.staffName,
              deptGuid: item.deptGuid || "",
              deptName: item.deptName || "",
              planAmount: +item.planAmount,
              assignTime: item.assignTime,
            })),
          })),
        };
        if (auto) {
          req.autoLabelAssign = true;
          delete req.labelAssignGroups;
        }
        // 转派字段段（2026-09-21 补齐历史空白：标注包拆分链此前不带转派参数，页面配置的转派提交即丢——
        // 受理页开关对标注包可见可配却从不生效；补齐后后端 taskChangeService 先落转派企业，自动匹配才有租户可读）
        if (!this.buildChangeServiceReq(req)) {
          return;
        }
        var confirmText;
        if (auto) {
          var scopeText = this.isChangeService == 'Y' ? '新执行方人员池内，根据新执行对象' : '委托方人员池内，根据原执行对象';
          confirmText = `系统将在${scopeText}筛选标注人员（所选部门及其下级部门内的人员与直接选中的人员；未配置执行对象时按人员池筛选）。候选人员须认证审核通过、生效认证记录中至少一张证书未过期、已签署平台协议并符合该标注行的科室/身份/职称要求；系统按现有规则分配数据量，不保证直接选中的人员都能分到任务${taskDetailList.length ? `，另含 ${taskDetailList.length} 条普通任务行走原分解链` : ''}，是否继续？`;
        } else {
          var groupText = req.labelAssignGroups
            .map((g, i) => `【${(this.labelAssignRows[i] || {}).datasetName || g.taskDetailGuid}】${g.items.length} 人`)
            .join('、');
          confirmText = `将按行拆分数据集并下发（${groupText}）${taskDetailList.length ? `，另含 ${taskDetailList.length} 条普通任务行走原分解链` : ''}，是否继续？`;
        }
        this.$confirm(confirmText, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/split`, req).then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // 受理提示（方案口径2）：后端把"候选不足已全员均摊/按人均取 M 人未参与名单"汇入成功
              // 响应 msg（无提示时 msg 为 CommonRes 默认值 "success"），有提示时展示给用户
              if (res.data.msg && res.data.msg !== 'success') {
                self.$message({ message: res.data.msg, type: 'warning', duration: 6000 });
              } else {
                self.$message.success('分解成功');
              }
              self.getDetail();
            } else {
              self.$message.error(res.data.msg);
            }
          }).catch(() => {
            this.fullscreenLoading = false;
          });
        });
      },
      // 转派字段段（开转派校验新执行方/新执行部门必选并组装进请求体；返回 false=校验未过调用方中断）。
      // 2026-09-21 抽公共方法：splitLabelTask（标注包拆分，含自动分解）与 submitReq（普通包）共用——
      // 此前该段只存在于普通包路径，标注包拆分链从不带转派参数，页面配置的转派提交即丢（历史空白）
      buildChangeServiceReq(req) {
        if (this.isChangeService == 'Y') {
          if (!this.newServiceTenantName) {
            this.$message.error('请选择新执行方');
            return false;
          }
          // handleSelectFactory 按名称回填 guid：名称有值但列表未匹配到时 guid 为空，
          // 不前置拦截会到后端自动匹配深处才报"未配置转派企业"，难定位
          if (!this.newServiceTenantGuid) {
            this.$message.error('新执行方信息不完整，请重新选择新执行方');
            return false;
          }
          if (this.departmentListII.length == 0) {
            this.$message.error('请选择新执行部门');
            return false;
          }
          req.newServiceTenantName = this.newServiceTenantName;
          req.newServiceTenantGuid = this.newServiceTenantGuid;
          var organisationInfo = [];
          this.departmentListII.forEach((item) => {
            organisationInfo.push({
              guid: item.guid,
              name: item.organisationName,
              objectType: item.nodeType == '2' ? '人员' : '组织'
            });
          });
          req.organisationInfo = JSON.stringify(organisationInfo);
          req.isChangeService = 'Y';
          req.oldOrganisationInfo = this.detail.organisationInfo;
        } else {
          req.newServiceTenantName = null;
          req.newServiceTenantGuid = null;
          req.organisationInfo = null;
          req.isChangeService = 'N';
          req.oldOrganisationInfo = null;
        }
        return true;
      },
      submitReq() {
        var self = this;
        // 含标注行的包（09-16 晚口径反转：流程不改，先分解后微调）——点【受理，并任务分解】
        // 弹选人框逐行选执行人员，确认即行级拆分（选人=分解动作的一部分）；普通包走原逻辑零改动
        // v26.3.3 受理自动分解（2026-09-21）：手动选人弹框暂隐藏——直接走服务端自动匹配分解；
        // 恢复手动交互时：注释掉下面自动分支、放开被注释的弹框分支即可（LabelAssignDialog 组件
        // 与 assign-candidates 端点契约未动）
        if (this.hasLabelRows) {
          this.splitLabelTask(null, true);
          return;
        }
        // if (this.hasLabelRows) {
        //   this.labelAssignVisible = true;
        //   return;
        // }
        var req = {
          guid: this.$route.query.guid,
          state: '待派发',
          currentTenantGuid:localStorage.guid
        };
        var taskDetailList = [];
        var tableDataII = this.tableDataII;
        var isReturn = '';
        // 转派字段段抽 buildChangeServiceReq 与标注包拆分链共用（2026-09-21：标注包此前不带转派参数的历史空白补齐）
        if (!this.buildChangeServiceReq(req)) {
          return;
        }
        tableDataII.forEach((item) => {
          // if (item.goodsInfo) {
          //   var goodsCountSum = 0;
          //   item.goodsInfo.forEach((l) => {
          //     goodsCountSum += l.goodsCount;
          //   });
          //   if (goodsCountSum !== item.taskTotal) {
          //     isReturn = '品种任务量之和必须等于任务总量';
          //   }
          // }
          taskDetailList.push({
            guid: item.guid,
            taskPrice: +item.taskPrice,
            taskTotal: +item.taskTotal,
            goodsInfo: item.goodsInfo ? JSON.stringify(item.goodsInfo) : null,
            taskTotalType: item.taskTotalType
          });
        });
        if (isReturn) {
          this.$message.error(isReturn);
          return;
        }

        req.taskDetailList = taskDetailList;

        self
          .$confirm('请确保任务量都已填写准确哦，以免影响任务分解，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            this.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/split`, req).then((res) => {
              this.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.disabled = true;
                self.$message.success('分解成功');
                self.getDetail();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          });
      },
      checkPost(){
        // N7 行级化：含标注行的包先做去派发预检（只读；质检未配/联动不满足/自审/数据集态逐行提示）
        if (this.hasLabelRows) {
          this.checkLabelDispatch(() => this.doCheckPost());
          return;
        }
        this.doCheckPost();
      },
      //原有派发预警链（任务量预警弹窗）
      doCheckPost(){
        let req = {
          taskMainGuid: this.$route.query.guid,
        };
        this.fullscreenLoading = true;
        this.api.get(`/${serverConfig.msSalesPerformService}/task/get-staff-all-task-info`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data && res.data.data.length) {
              this.tipsInfo = res.data.data;
              this.showDeliverTips = true;
            } else {
              this.surePost();
            }
          } else {
              self.$message.error(res.data.msg);
          }
        })

      },
      //标注包去派发预检：canDispatch=false 逐行列出不就绪原因并拦截（终校验在后端激活锁内）
      checkLabelDispatch(pass) {
        this.fullscreenLoading = true;
        this.api
          .get(`/${serverConfig.msSalesPerformService}/label-task/check-dispatch`, {
            taskGuid: this.$route.query.guid,
          })
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.error(res.data.msg || '派发预检失败');
              return;
            }
            const vo = res.data.data || {};
            if (vo.canDispatch) {
              pass && pass();
              return;
            }
            const msgs = (vo.rows || []).filter((r) => !r.ready && r.msg)
              .map((r) => `【${r.datasetName || r.taskDetailGuid}】${r.msg}`);
            this.$alert(msgs.length ? msgs.join('<br/>') : '存在未就绪的标注行，请先完成人员明细配置', '暂不可派发', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              type: 'warning',
            });
          })
          .catch(() => {
            this.fullscreenLoading = false;
          });
      },
      //确认发布
      surePost() {
        // let self = this;
        let req = {
          guid: this.$route.query.guid,
          state: '已派发',
          currentTenantGuid:localStorage.guid
        };
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success(!this.detail.bizApproveVO?'派发成功':'提审成功，请在【任务包派发审批】功能中查看提审内容和结果');
            this.getDetail();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      submitForm() {
        var goodsIndex = this.goodsIndex;
        this.visible2 = false;
        var taskTotal = 0;
        this.tableData.forEach((item) => {
          taskTotal += item.goodsCount;
        });
        this.tableDataII[goodsIndex].goodsInfo = this.tableData;
        this.tableDataII[goodsIndex].taskTotal = taskTotal;
      },
      getDeliverName(res) {
        var list = JSON.parse(res);
        var strList = [];
        list.forEach((item) => {
          strList.push(item.name);
        });
        return strList.join('、');
      },
      getReqName(res) {
        return JSON.parse(res).join('、');
      },
      getDeliverOrg(detail) {
        var taskDetailList = detail.taskDetailList;
        var orgList = [];
        taskDetailList.forEach((item) => {
          item.taskDetailOrganisationList.forEach((el) => {
            orgList.push(el.organisationGuid);
          });
        });

        var filterOrgList = new Set(orgList);

        return [...filterOrgList].length;
      },
      getDeliverStaff(detail) {
        var taskDetailList = detail.taskDetailList;
        var staffList = [];
        taskDetailList.forEach((item) => {
          item.taskDetailStaffList.forEach((el) => {
            staffList.push(el.staffGuid);
          });
        });
        var filterStaffList = new Set(staffList);
        return [...filterStaffList].length;
      },

      handleSelectionChange(val) {
        let self = this;
        self.multipleSelection = val;
      },

      //部门弹框选择
      handleNodeClick1(data) {
        this.departmentList = this.$refs.treeDep.getCheckedNodes(true);
        console.log();
        this.$forceUpdate();
      },
      //确定选择部门
      departmentSure() {
        this.departmentData = this.departmentList;
        this.visible3 = false;
      },
      handleSelectionChange1(val) {
        let self = this;
        self.delList = val;
        console.log(val);
      },
      //删除部门
      delDepartment() {
        let self = this;
        if (self.delList == null || self.delList.length == 0) {
          self.$message.error('请勾选成员！');
          return;
        }
        self.delList.forEach(function (j) {
          self.departmentList.forEach(function (i, index) {
            if (i.guid == j.guid) {
              self.departmentList.splice(index, 1);
              this.$refs.treeDep.setCheckedKeys([]);
            }
          });
        });
        self.delList.forEach(function (m) {
          self.area.forEach(function (n, idn) {
            if (JSON.parse(n).guid == m.guid) {
              self.area.splice(idn, 1);
            }
          });
        });
      },
      //删除单个部门
      delDepartmentSingle(index) {
        if (this.disabled) return;
        this.departmentData.splice(index, 1);
        this.departmentList = this.departmentData;
        this.area.splice(index, 1);
        this.$refs.treeDep.setCheckedKeys([]);
        // this.departmentList.splice(index,1)
      },
      handleCheckChange(data, checked, node) {
        if (checked == true) {
          this.checkedId = data.guid;
          this.$refs.treeDep.setCheckedNodes([data]);
        }
      },
      nodeClick(data, checked, node) {
        this.checkedId = data.guid;
        this.$refs.treeDep.setCheckedNodes([data]);
      },
      filterNodeDep(value, data) {
        if (!value) return true;
        return data.menuName.indexOf(value) !== -1;
      },
      //seeOrg(detail) {
       // this.rowDetail = detail;
       // this.visible4 = true;
        // this.serachOrgTxt = '';
        // this.taskDetail = detail;
        // this.tableOrg = detail.taskDetailOrganisationList;
        // this.tableOrg.forEach((item) => {
        //   item.planCount = !item.planCount && detail.taskTotalType == '不限量' ? '不限量' : item.planCount
        //   item.taskDetailStaffList = [];
        // });

        // this.tableOrg.forEach((i, index) => {
        //   detail.taskDetailStaffList.forEach((j) => {
        //     if (i.organisationName == j.organisationName) {
        //       i.taskDetailStaffList.push(j);
        //     }
        //   });
        // });

        // var tabHead = [
        //   {
        //     property: 'organisationName',
        //     label: '组织',
        //   },
        //   {
        //     property: 'planCount',
        //     label: '任务总量',
        //   },
        // ];

        // this.tableOrg.forEach((item, index) => {
        //   if (item.goodsInfo) {
        //     item.goods = JSON.parse(item.goodsInfo);
        //   }
        // });

        // this.tableOrg.forEach((p) => {
        //   if (p.goods) {
        //     p.goods.forEach((q) => {
        //       q.name = q.name + `(${q.goodsSpec})`;
        //       // q.name = q.name;
        //       p[q.name] = q.goodsCount;
        //     });
        //   }
        // });
        // var re = /[^\u4e00-\u9fa5]/;
        // for (const k in this.tableOrg[0]) {
        //   var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
        //   if (reg.test(k)) {
        //     tabHead.push({
        //       property: k,
        //       label: k,
        //     });
        //   }
        // }

        // this.tabHead = tabHead;
        // this.tableOriginOrg = this.tableOrg;

      //},
      // seePeople(detail) {
      //   this.taskStaffDetail = detail;
      //   this.visible5 = true;
      //   this.serachPeopleTxt = '';
      //   var taskDetailNoStaffList = [];
      //   console.log(detail)
      //   detail.taskDetailStaffList.forEach(item=>{
      //     if(item.planCount||detail.planCount=='不限量'){ //隐藏计划为0的
      //       taskDetailNoStaffList.push(item)
      //     }
      //   })
      //   this.tableStaff = taskDetailNoStaffList;
        
      //   var tabHead = [
      //     {
      //       property: 'staffName',
      //       label: '人员名称',
      //     },
      //     {
      //       property: 'planCount',
      //       label: '任务总量',
      //     },
      //   ];
      //   console.log(this.tableStaff)
      //   this.tableStaff.forEach((item, index) => {
          
      //     if (item.goodsInfo) {
      //       item.goods = JSON.parse(item.goodsInfo);
      //     }
      //   });

      //   this.tableStaff.forEach((p) => {
      //     if (this.taskStaffDetail.planCount == '不限量' && p.planCount == 0) {
      //       p.planCount = '不限量'
      //     }
      //     if (p.goods) {
      //       p.goods.forEach((q) => {
      //         if(!(q.name.indexOf('(')>-1&&q.name.indexOf(')')>-1)){
      //           q.name = q.name + `(${q.goodsSpec})`;
      //         }else{
      //           q.name = q.name 
      //         }
          
      //         p[q.name] = q.goodsCount;
      //       });
      //     }
      //   });

      //   for (const k in this.tableStaff[0]) {
      //     var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
      //     if (reg.test(k)) {
      //       tabHead.push({
      //         property: k,
      //         label: k,
      //       });
      //     }
      //   }
      //   console.log(this.tabHeadII);
      //   this.tabHeadII = tabHead;
      //   this.tableOriginStaff = this.tableStaff;
      // },
      modifyStaff() {
        var flag = false;
        var flag1 = false;
        var tableStaff = this.tableStaff;
        tableStaff.forEach((item) => {
          for (const k in item) {
            var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
            if (reg.test(k)) {
              //中文
              item.goods.forEach((j) => {
                if (j.name == k) {
                  j.goodsCount = +item[k];
                }
                if (j.goodsCount == 0) {
                  flag = true;
                }
              });
            }
          }
        });
        var newlist = [];
        tableStaff.forEach((item) => {
          // if (item.planCount == 0) {
          //   flag = true;
          // }
          if (item.goods) {
            item.goodsInfo = JSON.stringify(item.goods);
            var count = 0;
            item.goods.forEach((item) => {
              count += item.goodsCount;
            });
            // if (item.planCount != count) {
            //   flag1 = true;
            // }
            newlist.push({
              guid: item.guid,
              taskTotal: item.planCount,
              goodsInfo: item.goodsInfo,
            });
          } else {
            newlist.push({
              guid: item.guid,
              taskTotal: item.planCount,
            });
          }
        });
        if (flag1) {
          this.$message.error('品种量之和必须和任务总量相等');
          return;
        }
        let self = this;
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/change-goods-info`, newlist).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('修改成功');
            self.visible5 = false;
            self.visible4 = false;
            self.getDetail();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      //导入-上传文件
      uploadImage(file) {
        this.fileList = file;
      },
      modifyUplad() {
        let formData = new FormData();
        let file = this.fileList;
        let importUrl = this.detail.state=='已派发'&&this.detail.bizApproveVO?`/${serverConfig.msSalesPerformService}/task/data/import-detail?needApprove=Y&taskMainGuid=${this.$route.query.guid}`:`/${serverConfig.msSalesPerformService}/task/data/import-detail?taskMainGuid=${this.$route.query.guid}`
        if (file.length == 0) {
          this.$message.error('请上传文件清单！');
          return;
        }
        formData.append('file', file.file, file.filename);
        this.fullscreenLoading = true;
        this.api.postFile(importUrl, formData).then((res) => {
          this.fullscreenLoading = false;
          this.visible6 = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (res.data.data.error == 0) {
                this.$message.success('调整成功！');
              } else {
                this.importResult = res.data.data;
                this.$refs.importResult.open();
              }
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      //导入-上传前校验
      beforeAvatarUpload(file) {
        let testmsg = file.name ? file.name.split('.')[1] : '';
        const isJPG = testmsg === 'xls' || testmsg === 'xlsx'||testmsg === 'xlsm';
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
          this.$message.error('文件格式不正确!');
        }
        if (!isLt2M) {
          this.$message.error('文件大小不能超过10MB!');
        }
        return isJPG && isLt2M;
      },
      downloadTemplate() {
        let self = this;
        self.fullscreenLoading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/task/data/export-detail?guid=${this.$route.query.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      reportJx(colNames, datas, sheetName, fileNam) {
        let self = this;
        self.api
          .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
            colNames: colNames,
            datas: datas,
            sheetName: sheetName,
            fileNam: fileNam,
          })
          .then((res) => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let fileName = fileNam;
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
            self.fullscreenLoading = false;
          });
      },
      chooseDepartmentPerson() {
        let departmentListII = this.departmentListII;
        let personList = [];
        departmentListII.forEach(i => {
          personList.push(i.guid);
        });
        this.$refs.chooseDepartment.open(personList);
      },
      //获取人员部门名称
      getDepartmentName(list) {
        if (typeof list == 'string') {
          list = JSON.parse(list);
        }
        let personArr = [];
        let personTip = '';
        let departmentArr = [];
        let departmentTip = '';
        let personNum = 0;
        let departmentNum = 0;
        if (list && list.length > 0) {
          list.forEach(i => {
            if (i.objectType == '人员') {
              personArr.push(i.organisationName || i.name);
              personNum = personNum + 1;
            } else {
              departmentNum = departmentNum + 1;
              departmentArr.push(i.organisationName || i.name);
            }
          });
        }
        personTip =
          personArr.length > 2
            ? personArr.splice(0, 2).join('、') + `等${personNum}个人`
            : personArr.splice(0, 2).join('、');
        console.log(personArr);
        departmentTip =
          departmentArr.length > 2
            ? departmentArr.splice(0, 2).join('、') + `等${departmentNum}个部门`
            : departmentArr.splice(0, 2).join('、');
        return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
      },
        //提交所选部门
      onDepartmentSelect([personGuidList, departmentData]) {
        let departmentListII = [];
        departmentData.forEach(item => {
          departmentListII.push({
            organisationName: item.name,
            guid: item.guid,
            nodeType: item.nodeType
          })
        })
        this.departmentListII = departmentListII;
      },
      handleSelectFactory(val) {
        var tenantList = this.tenantList;
        this.newServiceTenantName = val;
        tenantList.forEach((item) => {
          if (item.tenantName == this.newServiceTenantName) {
            this.newServiceTenantGuid = item.guid;
          }
        });
      },
      //设为失效
      setCancel() {
        var self = this;
        self
          .$confirm('设为失效后，业务员将看不到此任务，确定此操作嘛？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            this.fullscreenLoading = true;
            var self = this;
            var req = {
              guid: this.detail.guid,
              state: '已失效',
              currentTenantGuid:localStorage.guid
            };
            self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit`, req).then((res) => {
              this.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('设置成功！');
                self.getDetail();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          });
      },
      //开启变更流程
      beginChangeFlow() {
        this.fullscreenLoading = true;
        let req = {
          guid:this.$route.query.guid,
          flowType:'00013'
        }
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task-flow-approve/staff-plant-flow-submit`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('变更流程开启成功');
            this.getDetail();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      // taskChange(val) {
      //   let self = this;
      //   let query = {
      //     taskDetailGuid: val
      //   };
      //   this.staffList = [];
      //   this.detailGuid = '';
      //   // this.taskCount = '';
      //   // this.staffGuid = '';
      //   this.organisationNames = ''

      //   this.taskDetailGuid = val;
      //   self.fullscreenLoading = true;
      //   self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-staff-task-info`, query).then((res) => {
      //     self.fullscreenLoading = false;
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       this.staffList = res.data.data;
      //       if(this.staffGuid){
      //         this.staffList.forEach(item=>{
      //           if(item.staffGuid ==this.staffGuid){
      //             this.taskCount = item.taskCount;
      //             this.organisationNames = item.organisationNames.join('、');
      //             this.detailGuid = item.guid;
      //           }
      //         })
      //       }
      //     } else {
      //       self.$message.error(res.data.msg);
      //     }
      //   });

      // },
      staffChange(val) {
        this.staffList.forEach(item => {
          if (item.staffGuid == val) {
            this.checkStaff(item);
            this.detailGuid = item.guid;
            this.taskCount = item.taskCount || 0;
            this.organisationNames = item.organisationNames.join('、');
          }
        })
     
      },

      checkStaff(item) {
        let req = {
          tenantGuid: this.detail.tenantGuid,
          objectList: [{
            objectName: item.staffName,
            objectGuid: item.staffGuid,
            objectType: '人员',
          }]
        }
        this.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-task/data/check-task-object`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if(res.data.data){
              this.staffGuid = '';
              this.taskCount = '';
              this.organisationNames = '';
              this.$message.error(res.data.data);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });

      },
      //是否展示变更按钮
      isShowModifyBtn(obj) {
        //00012 协配审核流程
        //00015 派发审核流程
        //00013 变更审核流程
        //历史的包
        if (obj.state == '待派发' && !obj.bizApproveVO) {
          return true
        }
        //协配的包审核通过 未发起审核（II）
        if (obj.state == '待派发' && obj.bizApproveVO.flowType == '00012' && obj.bizApproveVO.approveState == 'Y') {
          return true
        }
        //待派发的包 发起审核（II）不是在审核中
        if (obj.state == '待派发' && obj.bizApproveVO.flowType == '00015' && obj.bizApproveVO.approveState != 'A') {
          return true
        }

        //历史的包
        if (obj.state == '已派发' && !obj.bizApproveVO) {
          return true
        }
          //已派发的包 未发起审核（III）
        if (obj.state == '已派发' && obj.bizApproveVO.flowType == '00015' && obj.bizApproveVO.approveState == 'Y') {
          return true
        }
        //已派发的包 发起审核（III）不是在审核中
        if (obj.state == '已派发' && obj.bizApproveVO.flowType == '00013' && obj.bizApproveVO.approveState != 'A') {
          return true
        }
        return false;
      },
      //是否展示失效按钮
      isShowSetCancelBtn(obj){
        //00012 协配审核流程
        //00015 派发审核流程
        //00013 变更审核流程
        //历史的包
        if (obj.state == '已派发' && !obj.bizApproveVO) {
          return true
        }
         //派发的包审核通过 未发起审核（III）
        if (obj.state == '已派发' && obj.bizApproveVO.flowType == '00015' && obj.bizApproveVO.approveState == 'Y') {
          return true
        }
         //已派发的包 发起审核III 不在审核中
        if (obj.state == '已派发' && obj.bizApproveVO.flowType == '00013' && obj.bizApproveVO.approveState != 'A') {
          return true
        }
        return false;

      },
      //是否展示开启流程按钮
      isShowBeginFlowBtn(obj){
        //历史的包
        if (obj.state == '已派发' && !obj.bizApproveVO) {
          return false
        }
        //派发的包审核通过 未发起审核（III）
        if (obj.state == '已派发' && obj.bizApproveVO.flowType == '00015' && obj.bizApproveVO.approveState == 'Y') {
          return true
        }
        //已派发的包 发起审核III 不在审核中
        if (obj.state == '已派发' && obj.bizApproveVO.flowType == '00013' && obj.bizApproveVO.approveState != 'A') {
          return true
        }
        return false;
      },
      //是否展示去派发
      isShowPostBtn(obj) {
        //历史的包
        if (obj.state == '待派发' && !obj.bizApproveVO) {
          return true
        }
        //待派发的包 发起审核（II）不在审核中
        if (obj.state == '待派发' && obj.bizApproveVO.flowType == '00015' && obj.bizApproveVO.approveState != 'A') {
          return true
        }
        //协配的包审核通过 未发起审核（II）
        if (obj.state == '待派发' && obj.bizApproveVO.flowType == '00012' && obj.bizApproveVO.approveState == 'Y') {
          return true
        }
        return false;
      },
      getLevelList() {
        this.api
          .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=可限定产品的任务`)
          .then((resp) => {
            console.log(resp.data);
            if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let data = resp.data.data;

              if (!data || !data.length) return;
              let limitTaskDicts = [];
              data.forEach(item => {
                limitTaskDicts.push(item.value);
              })
              console.log(limitTaskDicts)
              this.limitTaskDicts = limitTaskDicts;

            }
          });
      },
      getLimitProducts(res){
        let goodsInfo = [];
        if (res.goodsInfo.length) {
          res.goodsInfo.forEach(item => {
            goodsInfo.push({
              guid: item,
              goodsName: null,
              unitStyle: null,
              goodsSpec: null,
            })
          })
        }else{
          goodsInfo = [];
        }
        let tableDataII = JSON.parse(JSON.stringify(this.tableDataII))
        //页面上的
        if (res.isAll == 'Y') {
          this.tableDataII.forEach(item => {
            if (this.limitTaskDicts.indexOf(item.taskContentType) > -1) {
              item.goodsInfo = goodsInfo;
            }
          })
        } else {
          this.tableDataII[this.currentIndex].goodsInfo = goodsInfo;
        }
        //接口层面的
        if (res.isAll == 'Y') {
          tableDataII.forEach(item => {
            if (this.limitTaskDicts.indexOf(item.taskContentType) > -1) {
              item.goodsInfo = JSON.stringify(goodsInfo);
            }
          })
        } else {
          tableDataII.forEach(item => {
            item.goodsInfo = JSON.stringify(item.goodsInfo);
          })
          tableDataII[this.currentIndex].goodsInfo = JSON.stringify(goodsInfo);
        }
        this.detail.taskDetailList = tableDataII
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit-goods`,  this.detail).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('调整成功');
            this.getDetail();
    
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      handleChooseGoods(index){
        this.currentIndex = index;
        this.visible2 =true;
      },
    },
  };
</script> 
<style scoped>
.title-search{
  display:flex;
  justify-content:space-between;
  margin-bottom: 20px;
  align-items: center;

}
.search-box{
  width:260px
}
.content {
  background: #fff;
  font-size: 18px;
}
/deep/.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}

/deep/.el-form-item__content {
  margin-left: 0px !important;
}
/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
  width:100%
}

/deep/ .el-table td {
  padding: 10px 0px;
}

.base-info {
  display: flex;
  align-items: center;
  margin-left: 23px;
  /* margin-bottom: 10px; */
}
.base-info .base-title {
  word-break: keep-all;
  font-size: 14px;
  display: flex;
}
.depart-choose {
  width: 300px;
  height: 34px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 6px;
}
.depart-choose span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.place-choose {
  padding-left: 10px;
  color: rgb(185, 185, 185);
}
.place-show {
  padding-left: 20px;
}
.p16 {
  padding-top: 0;
  padding-left: 30px;
  padding-right: 30px;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.management-list {
  display: flex;
  align-items: center;
  margin-left: 64px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #606266;
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.management-name {
  flex-shrink: 0;
}
.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  /* border: 1px solid grey; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
  border-radius: 20px;
  background: #DEEFEF;
  border: 0 none;
}
.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}
.input-item .input-title {
  margin-right: 14px;
}
input:disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
.date {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-left: 30px;
  background: #fff;
}
.date.first{
  padding-top: 10px;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  background: #fff;
  color: #323233;
  padding:16px 0 10px 20px;
  margin-bottom: 0;
}
.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}
.color-red {
  color: red;
}
.row-import {
  display: flex;
  margin-bottom: 20px;
  margin-left: 18px;
}
.row-import .left {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  padding-top: 4px;
}
.row-import .right {
  font-size: 14px;
}
.tipInfo {
  margin-top: 10px;
  color: #646464;
  line-height: 30px;
}
.task-tips{
  font-size:14px;
  font-style:normal;
  font-weight:normal;
  color: #999;
}
.ai-tips{
  height: 26px;
  background: #FFEEE3;
  color:#FF741E;
  line-height: 26px;
  font-size:13px;
  padding-left:10px;
}
.download-btns{
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  align-items: center;
}
.ai-item .lable{
  font-size:14px;
  color:#232323;
}
.ai-item{
  margin-top:20px;
}
.ai-item .value{
  color:#333;
  font-weight:600;
   margin-left:5px;
}
.ai-item .other1{
  color:#333;
  font-weight:600;
  margin-left:5px;
}
.ai-item .other2{
  color:#4fa1a4;
  text-decoration: underline;
  cursor:pointer;
}
.ai-item .ai-color{
  color: #4fa1a4;
  margin-left:8px;
}
.download-btns .lable{
  font-size:14px;
  color:#232323;
  flex:1;
}

.download-btns .btns{
  flex:1;
  display:flex;
  color:#323233;
  justify-content: flex-end;

}
.download-btns .btn1{
  margin-right:20px;
}
.download-btns .btn1,.download-btns .btn2{
  border:1px solid #D9D9D9;
  padding:6px;
  border-radius:4px;
}

/deep/.ai-class .el-dialog--center .el-dialog__body{
  padding:0 25px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;

}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}
.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

}

.header .back {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}
.header .task-title{
    flex:1;
    font-weight:500px;
}
.basic-conetent{
  background: #fff;
  margin-bottom:4px;
}
.btn-groups{
  background: #fff;
}
.btn-groups .btn-common{
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-border-green{
  background: #fff;
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.btn-border-gray{
  background: #f0f0f0;
  color: #323233;
  border: 1px solid #dcdee0; 
}
.btn-operate{
  text-align: left;
  padding-left:30px;


}
.btn-operate .btn-common {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.sum-txt{
  background: #fff;
  text-align: left;
  padding-left:30px;
}
.btn-operate .btn-common:last-child{
  margin-right: 30px;
}
.approve-item-list{
  display: flex;
  background: #fff;
  margin-bottom: 4px;
  align-items: center;
  padding-bottom: 16px;
  position: relative;
}
.approve-item-list .item{
  margin-left:40px;
  display: flex;
}
.approve-item-list .label{
 color: #606266;
 margin-right: 15px;
}
.approve-item-list .item.first{
  margin-left:50px;
}
.approve-item-list  img {
  position: absolute;
  right: 40px;
  width: 70px;
  bottom: 8px;
}
/* ===== v26.3.3 数据标注配置摘要 ===== */
.label-config-summary {
  text-align: left; /* 抵御全局 #app text-align:center 波及 */
  font-size: 13px;
  color: #606266;
  line-height: 28px;
}
.label-config-summary .sum-label {
  color: #909399;
}
.export-row {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
}
.export-tip {
  margin-left: 8px;
  font-size: 12px;
  color: #909399;
}
</style>
